/* unplugin-vue-components disabled */import script from "./desensitization.vue?vue&type=script&setup=true&lang=ts"
export * from "./desensitization.vue?vue&type=script&setup=true&lang=ts"

import "./desensitization.vue?vue&type=style&index=0&id=2b27630d&scoped=true&lang=css"

import exportComponent from "/root/workspace/njyx-frontend-pc_5kTN/node_modules/.pnpm/vue-loader@17.0.1_vue@3.2.47_webpack@5.75.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b27630d"]])

export default __exports__